module.exports = __webpack_public_path__ + "img/tubo-sinplecas.7ecadb64.png";